import { render, staticRenderFns } from "./BarChartPayOrder.vue?vue&type=template&id=b7cdbb84&"
import script from "./BarChartPayOrder.vue?vue&type=script&lang=js&"
export * from "./BarChartPayOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports